<template>

    <div id="media-stack">

        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask" @click="closeMe($event)">
                    <div class="modal-wrapper">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" v-html="language.warning"></h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" @click="showModal = false">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p v-html="language.warning_desc"></p>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" @click="showModal = false">{{ language.close }}</button>
                                <button class="btn btn-danger delete-button" v-on:click.prevent="removeMediaAdmin">
                                    <spinner v-if="loading" />
                                    {{ language.remove }}
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </transition>
        </div>

        <table class="table" v-if="dataStore.projectItems.length">

            <draggable v-if="editable" tag="tbody" :list="sortedItems" @start="drag=true" @end="drag=false" @change="onChange">

                <tr v-for="(media,indexMedia) in sortedItems" :key="'media-index-' + indexMedia" :data-id="media.id" class="draggable">
                    <td>{{ getQuestionType(media) }}</td>
                    <td>{{ getItemType(media) }}</td>
                    <td><span class="close" v-on:click.prevent="removeMedia(indexMedia)">{{ language.remove }}</span><span class="change-values" v-on:click.prevent="editMedia(indexMedia)">{{ language.edit }}</span></td>
                </tr>

            </draggable>

            <tbody v-if="!editable">

                <tr v-for="(media,indexMedia) in sortedItems" :key="'media-index-' + indexMedia" :data-id="media.id">
                    <td>{{ getQuestionType(media) }}</td>
                    <td>{{ getItemType(media) }}</td>
                    <td><span class="change-values" v-on:click.prevent="editMedia(indexMedia)">{{ language.show }}</span></td>
                </tr>

            </tbody>

        </table>

    </div>

</template>

<script>

import axios from 'axios'

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import Draggable from 'vuedraggable'

import Spinner from '../Spinner.vue'

export default {

    components : {
        Draggable,
        Spinner
    },

    computed: {

        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        },

        sortedItems: {

            get() {
                return this.dataStore.projectItems.sort((a, b) => a.sort - b.sort)
            },

            set(newArray) {
                return newArray
            }
        }
    },

    data() {
        return {
            dataStore,
            globalFunctions,
            showModal : false,
            indexToDelete : null,
            loading : false
        }
    },

    inject: [ 'language', 'superadmin', 'dialogueHasComments' ],

    methods: {

        editMedia: function(index) {

            this.dataStore.activeIndex = index

            const current = this.dataStore.projectItems[index];

            const db = current.hasOwnProperty("id") && !current.hasOwnProperty('updated') ? true : false;

            const questionType = db ? current.question.type : current.questionType;

            const type = db ? current.type : current.activeType;

            const allowUploadImage = db ? current.question.allow_upload_image : current.allowUploadImage

            const mapSearch = db ? current.show_navigation_coordinates : current.mapSearch

            const allowLimitMarkers = db ? current.question.limit_markers : current.allowLimitMarkers;

            const allowMultiAnswersScale = db ? current.question.allow_multi_answers_scale : current.allowMulti

            const allowGoodOptions = db ? current.allow_good_options : current.allowGoodOptions;

            const allowBadOptions = db ? current.allow_bad_options : current.allowBadOptions;

            const custom_hint = current.hint;

            let amountAnswers = db ? current.amount_of_answers : current.amountAnswers

            let responseFormDescription = db ? current.custom_label : current.responseFormDescription

            if( amountAnswers === null || amountAnswers === 0 ) {
                amountAnswers = 5;
            }

            let dataStore = { editMode : true, showInfoBoxEditor : false, activeType : type, activeIndex : index, allowUploadImage, mapSearch, allowMultiAnswersScale, amountAnswers, allowLimitMarkers, allowGoodOptions, allowBadOptions };

            this.globalFunctions.toggleAddMedia(questionType, true);

            if(type == 'question') {

                dataStore = {
                    ...dataStore,
                    activeQuestion : current.question.description
                }
            }

            else if(type == 'map') {

                let mapObject = {
                    centerLat : db ? current.center_lat : current.centerLat,
                    centerLng : db ? current.center_lng : current.centerLng,
                    paths : db ? this.globalFunctions.getPaths(current.item_paths) : current.paths,
                    questionType : questionType,
                    slide_info : current.slide_info,
                    index : index
                }

                dataStore = {
                    ...dataStore,
                    activeMapObj : Object.assign(this.dataStore.activeMapObj, mapObject),
                    disableMapEditor : false,
                    center : mapObject.centerLat + ',' + mapObject.centerLng,
                    hint : custom_hint,
                    responseFormDescription
                }

                if(current.slide_info !== ''){

                    dataStore = {
                        ...dataStore,
                        showInfoBoxEditor : true
                    }
                }
            }

            else if(type == 'image') {

                dataStore = {
                    ...dataStore,
                    popUpMediaFile : current.hasOwnProperty('assets') ? current.assets : current.file,
                    activeFileName : current.hasOwnProperty('assets') ? current.assets : current.name,
                    hint : custom_hint,
                    responseFormDescription
                }

                if(current.slide_info !== ''){

                    dataStore = {
                        ...dataStore,
                        showInfoBoxEditor : true,
                    }
                }

                if(questionType === 'scale' || questionType === 'freetext') {

                    dataStore = {
                        ...dataStore,
                        activeQuestion : current.question.description,
                    }
                }

            }

            else if(type == 'video') {

                dataStore = {
                    ...dataStore,
                    activeVideoUrl : current.videourl ? current.videourl : current.assets,
                    activeQuestion : current.question.description,
                    typeOfVideo : current.question.youtube_video
                }
            }

            else if(type == '3D') {

                dataStore = {
                    ...dataStore,
                    active3dIframe : current.active3dIframe ? current.active3dIframe : current.assets,
                    activeQuestion : current.question.description,
                }
            }

            if(questionType === 'scale') {

                dataStore = {
                    ... dataStore,
                    activeScaleType : db ? (current.question.options.length === 0 ? 'DEFAULT' : 'CUSTOM' ) : this.dataStore.activeScaleType,
                    allowUploadImage : false,
                    project : {
                        ... this.dataStore.project,
                        scaleOptions : db ? current.question.options : current.scaleOptions
                    }
                }
            }

            this.dataStore = Object.assign(this.dataStore, dataStore)
        },

        removeMedia: function(index) {

            if( this.dialogueHasComments && this.superadmin ) {
                this.indexToDelete = index
                this.showModal = true
            } else {
                this.removeMediaDefault.apply(null, arguments)
            }

        },

        removeMediaAdmin: function() {

            this.loading = true

            setTimeout(() => {
                this.removeMediaDefault(this.indexToDelete)
                this.indexToDelete = null
                this.showModal = false
            }, 500)

        },

        removeMediaDefault: async function(index) {

            let item = this.dataStore.projectItems[index];

            this.dataStore.projectItems.splice( index, 1);

            if(item.id) {

                try {
                    const response = await axios.post(`/api/delete-item/${item.id}`, { headers: { 'Content-Type': 'multipart/form-data' } } );

                    if(response) {
                        this.$emit('remove-item', item)
                    }

                } catch (error) {
                    console.error(error)
                }

            } else {
                this.$emit('remove-item', item)
            }
        },

        onChange: function(event) {

            const index = event.moved.newIndex

            const item = event.moved.element

            let newSorting = this.sortedItems.filter(i => i !== item );

            newSorting.splice(index, 0, item)

            newSorting.map((item, index) => item.sort = index + 1 )
            
            this.sortedItems = newSorting;

            axios.post(`/api/sort-project-items-admin`,
                {
                    data : this.sortedItems,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
        },

        getQuestionType: function(media) {

            let type = media.hasOwnProperty('id') && !media.hasOwnProperty('updated') ? media.question.type : media.questionType

            const mediaType = media.hasOwnProperty('id') && !media.hasOwnProperty('updated') ? media.type : media.activeType

            if( type === 'goodbad' && ( mediaType === 'image' || mediaType === 'map' ) ) {
                type = type + '_' + mediaType
            }

            return this.language.add_type_question_type[type]
        },

        getItemType: function(media) {
            const type = media.hasOwnProperty('id') && !media.hasOwnProperty('updated') ? media.type : media.activeType;
            return this.language.add_type_item_type[type]
        },

        closeMe: function(e) {

            if(e.target.classList.contains('modal-wrapper')) {
                this.showModal = false
            }

        },

    }
};

</script>
